<template>
    <div class=''>
        <Headers :windowWidth="windowWidth"/>
        <div class="detail">
            

            <!-- 顶部面包屑 -->
            <div class="top_box">
                <!-- <el-breadcrumb separator="/">
                    <el-breadcrumb-item :replace="true" :to="{ path: '/carbon' }">{{$t('detail.carbonProject')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('detail.projectDetail')}}</el-breadcrumb-item>
                </el-breadcrumb> -->
                <div class="title1" @click="gotoback">{{$t('detail.carbonProject')}}</div>
                <div class="title2">/</div>
                <div class="title3">{{$t('detail.projectDetail')}}</div>
            </div>
            <!-- 进度条 -->
            <div style="margin:40px 0 60px;">
                <el-steps :active="steps" align-center finish-status="success">
                    <el-step :description="$t('detail.steps_one')"></el-step>
                    <el-step :description="$t('detail.steps_two')"></el-step>
                    <el-step :description="$t('detail.steps_three')"></el-step>
                    <el-step :description="$t('detail.steps_four')"></el-step>
                    <el-step :description="$t('detail.steps_five')"></el-step>
                    <el-step :description="$t('detail.steps_six')"></el-step>
                </el-steps>
            </div>

            <!-- 提示 -->
            <div class="top_title">
                <div class="text_box" style="width:60%">{{from.projectName}}</div>
                <div class="text_box" style="color:#1E1E1E">{{$t('detail.value')}} {{from.provider}}</div>
            </div>

            <!-- 地图信息 -->
            <div class="map">
                <!-- 地图 -->
                <div class="map_box" id="map"></div>
                <!-- 地图详情 -->
                <div class="map_detail">
                    <div class="h1">{{$t('detail.maptitle')}}</div>
                    <div class="banner_box">
                        <el-row class="banner">
                            <el-col :span="12" class="key">{{$t('detail.projectid')}}</el-col>
                            <el-col :span="12" class="value">{{from.id ? from.id : '--'}}</el-col>
                        </el-row>
                        <el-divider></el-divider>
                        <el-row class="banner">
                            <el-col :span="12" class="key">{{$t('detail.pjname')}}</el-col>
                            <el-col :span="12" class="value">{{from.projectName ? from.projectName : '--'}}</el-col>
                        </el-row>
                        <el-divider></el-divider>
                        <el-row class="banner">
                            <el-col :span="12"  class="key">{{$t('detail.pjtype')}}</el-col>
                            <el-col :span="12"  class="value">{{from.projectType ? from.projectType : '--'}}</el-col>
                        </el-row>
                        <el-divider></el-divider>
                        <el-row class="banner">
                            <el-col :span="12"  class="key">{{$t('detail.projectstatus')}}</el-col>
                            <el-col :span="12"  class="value">{{from.idRegistry ? from.idRegistry : '--'}}</el-col>
                        </el-row>
                        <el-divider></el-divider>
                        <el-row class="banner">
                            <el-col :span="12"  class="key">{{$t('detail.country')}}</el-col>
                            <el-col :span="12"  class="value">{{from.country ? from.country : '--'}}</el-col>
                        </el-row>
                        <el-divider></el-divider>
                        <el-row class="banner">
                            <el-col :span="12"  class="key">{{$t('detail.pjstate')}}</el-col>
                            <el-col :span="12"  class="value">{{from.state ? from.state : '--'}}</el-col>
                        </el-row>
                        <el-divider></el-divider>
                        <el-row class="banner">
                            <el-col :span="12"  class="key">{{$t('detail.est')}}</el-col>
                            <el-col :span="12"  class="value">{{from.proponent ? from.proponent : '--'}}</el-col>
                        </el-row>
                        <el-divider></el-divider>
                        <el-row class="banner">
                            <el-col :span="12"  class="key">{{$t('detail.pj3rd')}}</el-col>
                            <el-col :span="12"  class="value">{{from.verifier ? from.verifier : '--'}}</el-col>
                        </el-row>
                        <el-divider></el-divider>
                        <el-row class="banner">
                            <el-col :span="12"  class="key">{{$t('detail.csards')}}</el-col>
                            <el-col :span="12"  class="value">{{from.standards ? from.standards : '--'}}</el-col>
                        </el-row>
                        <el-divider></el-divider>
                        <el-row class="banner">
                            <el-col :span="12"  class="key">{{$t('detail.cmlogy')}}</el-col>
                            <el-col :span="12"  class="value">{{from.methodology ? from.methodology : '--'}}</el-col>
                        </el-row>
                        <el-divider></el-divider>
                        <el-row class="banner">
                            <el-col :span="12"  class="key">{{$t('detail.pjststus')}}</el-col>
                            <el-col :span="12"  class="value">{{from.status ? from.status : '--'}}</el-col>
                        </el-row>
                        <el-divider></el-divider>
                        <el-row class="banner">
                            <el-col :span="12"  class="key">{{$t('detail.cpiod')}}</el-col>
                            <el-col :span="12"  class="value">{{from.period ? from.period : '--'}}</el-col>
                        </el-row>
                        <el-divider></el-divider>
                        <el-row class="banner">
                            <el-col :span="12"  class="key">{{$t('detail.asits')}}</el-col>
                            <el-col :span="12"  class="value">{{Number(from.credits) ? addComma((from.credits/1).toFixed(0)) : '--'}}</el-col>
                        </el-row>
                        <el-divider></el-divider>
                        <el-row class="banner">
                            <el-col :span="12"  class="key">{{$t('detail.nfdt')}}</el-col>
                       
                            <el-col :span="12"  class="value"><a :underline="false" target="_blank" :href="from.nftContractUrl">{{from.nftTransactionHash ? from.nftTransactionHash : '--'}}</a></el-col>
                        </el-row>
                        <el-divider></el-divider>
                    </div>
                </div>
            </div>

            <!-- 说明信息 -->
            <div class="ban_box">
                <div class="text">
                    <div class="h1">{{$t('detail.text_title')}}</div>
                    <div class="text_banner">{{from.description}}</div>
                </div>
            </div>

            <!-- List列表 -->
            <div class="list_box">
                <div class="list_text">{{$t('detail.issuancelist')}}</div>
                <el-table empty-text="Data Temporarily Unavailable" :data="tableData" stripe style="width: 100%" :cell-style="{padding:'10px 20px 10px 25px',fontSize:'20px',fontFamily: 'ArialMT',color: '#1E1E1E'}" :header-cell-style="{background:'#F8F9FA',padding:'10px 20px 10px 25px',fontSize:'20px',fontFamily: 'ArialMT',color: '#626262'}">
                    <el-table-column prop="vintage" :label="$t('detail.vin')"></el-table-column>
                    <el-table-column prop="quantity" :label="$t('detail.quantity')">
                        <template slot-scope="scope">
                            {{addComma(scope.row.quantity)}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="issuanceDate" :label="$t('detail.issdate')">
                        <template slot-scope="scope">
                            {{formatDate(scope.row.issuanceDate)}}
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- Project列表 -->
            <div class="list_box">
                <div class="list_text">{{$t('detail.projectlist')}}</div>
                <el-table empty-text="Data Temporarily Unavailable" :data="projectData.slice((currentPage - 1) * pageSize,currentPage * pageSize)" stripe style="width: 100%" :cell-style="{padding:'10px 20px 10px 25px',fontSize:'20px',fontFamily: 'ArialMT',color: '#1E1E1E'}" :header-cell-style="{background:'#F8F9FA',padding:'10px 20px 10px 25px',fontSize:'20px',fontFamily: 'ArialMT',color: '#626262'}">
                    <el-table-column prop="documentName" :label="$t('detail.doname')"></el-table-column>
                    <el-table-column prop="documentType" :label="$t('detail.dotype')"></el-table-column>
                    <el-table-column prop="updateDate" :label="$t('detail.update')">
                        <template slot-scope="scope">
                            {{formatDate(scope.row.updateDate)}}
                        </template>
                    </el-table-column>
                    <el-table-column label="Action">
                        <template slot-scope="scope">
                            <div class="gr_text" @click="download(scope.row)">{{$t('detail.view')}}</div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="fenye">
                    <el-pagination
                        v-if="projectData.length != 0"
                        @current-change="handleCurrentChange"
                        :page-size="pageSize"
                        background
                        layout="prev, pager, next"
                        class="pagination"
                        prev-text="<"
                        next-text=">"
                        :total="projectData.length"
                        >
                    </el-pagination>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》'
import Headers from '@/components/header/index.vue'
import carbonRegistry from '@/api/carbonRegistry.js'
import { formatDate , formatDateTime} from "@/util/date";
import {formatNum} from '@/util/number';
export default {
  name: 'detail',
  // import引入的组件需要注入到对象中才能使用
  components: {Headers},
  data () {
    // 这里存放数据
    return {
        tableData:[],
        projectData:[],
        from:{},
        id:this.$route.query.id,
        pageSize: 5,
        currentPage: 1,
        windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
        steps:null
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
        this.id = this.$route.query.id
        this.getDetail()
        let that = this
        window.onresize = () => {
            return (() => {
                window.fullWidth = document.documentElement.clientWidth;
                that.windowHeight = window.fullHeight;  // 高
            })()
        };
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {}, // 如果页面有keep-alive缓存功能，这个函数会触发
  //修改列表页的meta值，false时再次进入页面会重新请求数据。
  beforeRouteLeave(to, from, next) {
    if (to.path == "/carbon") {
      to.meta.keepAlive = true;
    } 
    next();
  },
  // 方法集合
  methods: {
        formatDate:formatDate,
        formatNum:formatNum,
        gotoback(){
            this.$router.back()
        },
        // 定义添加逗号的方法
        addComma(num = 0) {
            return num.toString().replace(/\d+/, function(n) {
                return n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
            });
        },
        initMap(lat,lng) {
            // Create the map.
            const myLatLng = { lat: lat, lng: lng };
            const map = new google.maps.Map(document.getElementById('map'), {
                zoom: 8,
                center: myLatLng,
            });

            new google.maps.Marker({
                position: myLatLng,
                map,
                title: "",
            });
            //多点位
            // const map = new google.maps.Map(document.getElementById("map"), {
            //     center: new google.maps.LatLng(-33.91722, 151.23064),
            //     zoom: 16,
            // });
            // const features = [
            //     {
            //         position: new google.maps.LatLng(-33.91721, 151.2263),
            //         type: "info",
            //     },
            //     {
            //         position: new google.maps.LatLng(-33.91539, 151.2282),
            //         type: "info",
            //     },
            //     {
            //         position: new google.maps.LatLng(-33.91747, 151.22912),
            //         type: "info",
            //     },
            //     {
            //         position: new google.maps.LatLng(-33.9191, 151.22907),
            //         type: "info",
            //     },
            // ]
            // for (let i = 0; i < features.length; i++) {
            //     const marker = new google.maps.Marker({
            //         position: features[i].position,
            //         map: map,
            //     });
            // }
        },
        //获取详情
        getDetail(){
            let params = {
                projectSiteId:this.id
            }
            carbonRegistry.getProject(response =>{
                let country = JSON.parse(sessionStorage.getItem('form'))
                if(response){
                    this.from = response.project
                    this.tableData = response.project.issuanceList
                    this.projectData = response.project.projectDocumentList
                    this.initMap(this.from.latitude,this.from.longitude)
                    this.steps = response.project.localStatus
                    // carbonRegistry.getLatDetail(responses =>{
                    //     if(responses.code == 200){
                    //         this.initMap(responses.data.initialLatitude,responses.data.initialLongitude)
                    //     }
                    // },{country:country.country ? country.country : 'Indonesia'})
                }
            },params)
        },
        handleCurrentChange(updateCurrentPage) {
            this.currentPage = updateCurrentPage;
        },
        download(item) {
            console.log(item)
            window.location.href = item.url
        }
  }
}
</script>

<style lang='scss' scoped>
//@import url(); 引入公共css类
::v-deep .detail{
    width: 1440px;
    max-width: 1440px;
    margin: 0 auto;
    padding-bottom: 50px;
    .top_box{
        padding: 27px 0 40px 0;
        display: flex;
        .title1{
            font-size: 20px;
            font-family: ArialMT;
            color: #626262;
            line-height: 23px;
            cursor: pointer;
        }
        .title2{
            margin: 0 10px;
            font-size: 20px;
            cursor: pointer;
        }
        .title3{
            font-size: 20px;
            font-family: ArialMT;
            color: #1E1E1E;
            line-height: 23px;
            cursor: pointer;
        }
        .el-breadcrumb__inner a, .el-breadcrumb__inner.is-link{
            font-size: 20px;
            font-family: ArialMT;
            color: #626262;
            line-height: 23px;
        }
        .el-breadcrumb__inner{
            font-size: 20px;
            font-family: ArialMT;
            color: #1E1E1E;
            line-height: 23px;
        }
        .el-breadcrumb{
            font-size: 20px;
        }
    }
    .top_title{
        height: 78px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 10px;
        background-color: #F4FAF9;
        padding: 0 40px 0 53px;
        .text_box{
            font-size: 20px;
            font-family: ArialMT;
            color: #158869;
            line-height: 21px;
        }
    }
    .map{
        display: flex;
        margin-top: 30px;
        box-shadow: 0px 0px 24px 0px rgba(0, 73, 53, 0.09);
        .map_box{
            width: 50%;
            max-width: 50%;
        }
        .map_detail{
            width: calc(50% - 39px - 64px);
            max-width: calc(50% - 39px - 64px);
            padding: 37px 39px 58px 64px;
            .h1{
                font-size: 48px;
                font-family: Arial-BoldMT, Arial;
                font-weight: normal;
                color: #1E1E1E;
                line-height: 55px;
            }
            .banner_box{
                margin-top: 16px;
            }
            .banner{
                display: flex;
                justify-content: space-between;
                padding: 11px 0;
                .key{
                    font-size: 20px;
                    font-family: ArialMT;
                    color: #626262;
                    line-height: 23px;
                    text-align: left;
                }
                .value{
                    // max-width: 330px;
                    font-size: 20px;
                    font-family: ArialMT;
                    color: #424242;
                    line-height: 23px;
                    text-align: right;
                    a{
                        width: 100%;
                        display: inline-block;
                        text-overflow: ellipsis;
                        overflow: hidden;
                    }
                }
            }
        }
    }
    .ban_box{
        // height: 380px;
        margin-top: 100px;
        background: #F8F9FA;
        border-radius: 10px;
        // background: url('../../assets/img/bj2.png') no-repeat 100% 100%;
        .text{
            padding: 39px 41px 55px 53px;
            .h1{
                font-size: 48px;
                font-family: Arial-BoldMT, Arial;
                font-weight: 600;
                color: #1E1E1E;
                line-height: 55px;
            }
            .text_banner{
                margin-top: 33px;
                font-size: 20px;
                font-family: ArialMT;
                color: #626262;
                line-height: 32px;
            }
        }
    }
    .list_box{
        margin-top: 70px;
        .list_text{
            font-size: 48px;
            font-family: Arial-BoldMT, Arial;
            font-weight: normal;
            color: #1E1E1E;
            line-height: 55px;
            margin-bottom: 40px;
        }
        .gr_text{
            color: #158869;
            cursor: pointer;
        }
        .fenye{
            display: flex;
            justify-content: end;
            margin-top: 20px;
        }
    }
    .el-divider--horizontal{
        margin: 5px 0;
    }
    .el-divider{
        background-color: #D0D0D0;
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active{
        background-color: #f4f4f5;
        color: #158869;
    }

    .el-step__description{
        margin-top:10px;
        font-size: 16px;
        padding-left: 10%;
        padding-right: 10%;
        line-height: 24px;
        color: #626262;
    }
    .el-step__line-inner{
        background-color: #158869;
    }
    .el-step__head.is-success{
        color: #158869;
        border-color: #158869;
    }
    
    .is-success {
        .el-step__icon.is-text{
            background-color: #158869;
            color: #ffffff;
        }
        
    }
    .el-step__description.is-success{
        color: #158869;
    }
    .el-step__description.is-process{
        color: #626262;
    }
    .is-process{
        .el-step__icon.is-text{
            background-color: #FFFFFF;
            color: #C0C4CC;
            border-color: #C0C4CC;
        }
    }
    // .el-step__description.is-success{
    //     color: #158869;
    // }
    // .el-step__icon-inner.is-status{
    //     color: #ffffff;
    // }
}

</style>
